var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArticlePreviewBorder = function SvgArticlePreviewBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 343 44",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.68 24.587c-5.645 1.026-10.559 3.619-15.496 6.223-1.847.975-3.697 1.95-5.59 2.847-1.838.873-4.136 1.612-6.09 1.41l-.125-.012c-5.934-.6-11.924-1.206-17.743-2.608-7.182-1.68-14.306-2.15-21.373-.201-9.135 2.553-18.155 3.56-27.635 1.68-6.522-1.262-13.274-1.61-20.01-1.958h-.005c-.798-.041-1.595-.082-2.392-.125-1.034-.05-2.068-.105-3.104-.16-5.986-.32-11.989-.642-17.867.16-7.584.94-15.053 3.023-22.349 5.442-13.732 4.502-27.176 3.36-40.448-1.008-7.39-2.408-14.64-5.2-21.883-7.992-4.075-1.57-8.149-3.14-12.244-4.64a4303.125 4303.125 0 0 1-8.373-3.074c-11.16-4.106-22.32-8.213-33.626-11.975l-1.708-.566C50.433 5.313 42.097 2.546 33.61 1.54 25.296.534 16.852.433 8.424.331A701.005 701.005 0 0 1 0 .199v43h343v-19.62c-1.386.176-2.747.408-4.116.642h-.001c-.73.125-1.464.25-2.203.367Z",
    stroke: "#1A1717",
    fill: "#1A1717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320.88 18.338c.759 3.794-3.761 8.843-7.005 9.731-3.244.888-9.799 1.163-10.558-2.631-.759-3.794 4.552-8.9 7.796-9.787 3.244-.888 9.008-1.107 9.767 2.687ZM333.52 14.979c.473.958-.574 2.687-1.808 3.58-1.728 1.249-2.859 1.712-4.208 1.137-2.258-.606-1.461-3.884.142-4.966 1.604-1.083 4.948-1.626 5.874.249Z",
    fill: "#1A1717"
  })));
};

export default SvgArticlePreviewBorder;